import { every, isEmpty } from 'lodash/fp';

import { getAvailabilityPricingHashes } from '../../../selectors/availability';
import { ApplicationState } from '../../../types';
import { WithAvailabilityHash, WithCurrencyCode } from '../../../types/selectors/selectorPropTypes';
import { hasPricingRatesCurrencyCode } from '../selectors';

export const hasAvailabilityPricingCurrencyCode = (
    state: ApplicationState,
    { currencyCode, availabilityHash }: WithCurrencyCode & WithAvailabilityHash
) => {
    const pricingHashes = getAvailabilityPricingHashes(state, { availabilityHash });

    if (isEmpty(pricingHashes)) {
        return false;
    }

    return every((pricingHash) => hasPricingRatesCurrencyCode(state, { pricingHash, currencyCode }), pricingHashes);
};
